// AI探索境界: docs/design/foundation/responsibility/shopify-theme-boundary-map.md
(function () {
  const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content"];

  // ---- 1) UTMをlocalStorageへ（last touch：UTMがある時だけ上書き）----
  const params = new URLSearchParams(window.location.search);
  keys.forEach((k) => {
    const v = params.get(k);
    if (v) localStorage.setItem(k, v);
  });

  function getUtmObj() {
    const o = {};
    keys.forEach((k) => (o[k] = localStorage.getItem(k) || ""));
    return o;
  }

  async function writeCartAttributesIfAny() {
    const utm = getUtmObj();
    if (!utm.utm_source && !utm.utm_medium && !utm.utm_campaign && !utm.utm_content) return;

    const cart = await fetch("/cart.js", { credentials: "same-origin" }).then((r) => r.json());

    // 既存attributes（例: locksmith）を保持しつつUTMだけ上書き
    const merged = { ...(cart.attributes || {}), ...utm };

    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ attributes: merged }),
    });
  }

  // ---- 2) ページロード時：カートに商品があれば反映（基本）----
  document.addEventListener("DOMContentLoaded", () => {
    writeCartAttributesIfAny().catch(() => {});
  });

  // ---- 3) 追加/変更/更新（AJAX）をフック：クイック追加でも必ず反映 ----
  const shouldHook = (url) => {
    if (!url) return false;
    const u = String(url);
    return (
      u.includes("/cart/add") ||
      u.includes("/cart/add.js") ||
      u.includes("/cart/change") ||
      u.includes("/cart/change.js") ||
      u.includes("/cart/update") ||
      u.includes("/cart/update.js")
    );
  };

  // fetch をフック
  const _fetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === "string" ? input : (input && input.url) || "";
    const p = _fetch.apply(this, arguments);
    if (shouldHook(url)) {
      // カート操作の直後に属性反映（少し待ってから）
      p.finally(() => setTimeout(() => writeCartAttributesIfAny().catch(() => {}), 300));
    }
    return p;
  };

  // XHR をフック（古い実装対策）
  const _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__utm_hook_url = url;
    return _open.apply(this, arguments);
  };
  const _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    this.addEventListener("loadend", () => {
      if (shouldHook(this.__utm_hook_url)) {
        setTimeout(() => writeCartAttributesIfAny().catch(() => {}), 300);
      }
    });
    return _send.apply(this, arguments);
  };
})();